import React from 'react';
import GenericNomenclatureList from './GenericNomenclatureList';
import { useConditionTypeMutations } from '../../../hooks/useNomenclatures';

const ConditionTypeList = ({ items, onUpdate }) => {
  const mutations = useConditionTypeMutations();

  const fields = [
    { name: 'category', label: 'Category', type: 'text', placeholder: 'e.g., Prerequisite, Safety' },
    { name: 'color', label: 'Color', type: 'color' }
  ];

  return (
    <GenericNomenclatureList
      items={items}
      type="condition-types"
      title="Condition Types"
      fields={fields}
      mutations={mutations}
      onUpdate={onUpdate}
    />
  );
};

export default ConditionTypeList;



